import { render } from "./AddUserTable.vue?vue&type=template&id=0c72aedb&scoped=true"
import script from "./AddUserTable.vue?vue&type=script&lang=js"
export * from "./AddUserTable.vue?vue&type=script&lang=js"

import "./AddUserTable.vue?vue&type=style&index=0&id=0c72aedb&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c72aedb"]])

export default __exports__